import { CHECK_IN_BAGGAGE } from '../../../products';
import { BAGGAGE_VALUES, baggagePricePerTraveler } from '../../common/utils/baggageUtils';
const PRESELECTION_VALUES = {
  none: 'NONE',
  yes: 'YES_SELECTED',
  no: 'NO_SELECTED'
};
export const getPreselected = travelers => {
  return travelers === null || travelers === void 0 ? void 0 : travelers.some(traveler => (traveler === null || traveler === void 0 ? void 0 : traveler.productPreSelection) === PRESELECTION_VALUES.yes);
};
export const getTravelersPrimaryFlow = order => baggagePricePerTraveler(order);
export const getTravelersPostbooking = (productId, order) => {
  var _order$availableExtra, _baggageProduct$sellS, _order$travelers;
  const baggageProduct = order === null || order === void 0 || (_order$availableExtra = order.availableExtraProducts) === null || _order$availableExtra === void 0 ? void 0 : _order$availableExtra.find(product => String(product === null || product === void 0 ? void 0 : product.id) === String(productId));
  const baggageSpecification = (baggageProduct === null || baggageProduct === void 0 || (_baggageProduct$sellS = baggageProduct.sellSpecification) === null || _baggageProduct$sellS === void 0 ? void 0 : _baggageProduct$sellS.sellPriceBaggage) || [];
  const eligibleTravelerIdsForBaggage = baggageSpecification.flatMap(product => product === null || product === void 0 ? void 0 : product.travelerId).filter(Boolean) || [];
  return order === null || order === void 0 || (_order$travelers = order.travelers) === null || _order$travelers === void 0 || (_order$travelers = _order$travelers.filter(_ref => {
    let {
      id
    } = _ref;
    return id !== undefined && eligibleTravelerIdsForBaggage.length && (eligibleTravelerIdsForBaggage === null || eligibleTravelerIdsForBaggage === void 0 ? void 0 : eligibleTravelerIdsForBaggage.includes(String(id)));
  })) === null || _order$travelers === void 0 ? void 0 : _order$travelers.map(traveler => {
    var _options$0$price, _options$, _markup$value;
    const {
      options = []
    } = (baggageSpecification === null || baggageSpecification === void 0 ? void 0 : baggageSpecification.find(currTraveler => String(currTraveler === null || currTraveler === void 0 ? void 0 : currTraveler.travelerId) === String(traveler === null || traveler === void 0 ? void 0 : traveler.id))) || {};
    const {
      markup,
      price
    } = (_options$0$price = (_options$ = options[0]) === null || _options$ === void 0 ? void 0 : _options$.price) !== null && _options$0$price !== void 0 ? _options$0$price : {};
    return {
      ...traveler,
      name: (traveler === null || traveler === void 0 ? void 0 : traveler.fullName) || '',
      markup: (_markup$value = markup === null || markup === void 0 ? void 0 : markup.value) !== null && _markup$value !== void 0 ? _markup$value : null,
      price: price === null || price === void 0 ? void 0 : price.value
    };
  });
};
export const getBaggageWeight = _ref2 => {
  let {
    numberOfPieces,
    weight,
    weightUnit,
    texts
  } = _ref2;
  if (numberOfPieces && weight && weightUnit) {
    const {
      pieces,
      weightDescription,
      weightValues
    } = texts;
    const baggageWeightValues = `${pieces} ${weightValues}`;
    return weightDescription(baggageWeightValues);
  }
  return '';
};
export const formCheckedBaggageWeightSizeDescription = _ref3 => {
  let {
    weight,
    weightUnit,
    numberOfPieces,
    t
  } = _ref3;
  const weightDescription = weight ? t('Product.BaggagePerTraveler.Weight', weight, weightUnit) : '';
  const piecesDescription = numberOfPieces ? `${t('Product.BaggagePerTraveler.Pieces', numberOfPieces)}` : '';
  const baggageWeightDescription = `${piecesDescription} ${weightDescription}`;
  return baggageWeightDescription.trim();
};
export const formCombinedBagWeightDescription = _ref4 => {
  let {
    weight,
    weightUnit,
    numberOfPieces,
    piecesOfSecondBag,
    weightOfSecondBag,
    weightUnitOfSecondBag,
    t
  } = _ref4;
  const weightDescription = weight === weightOfSecondBag && weightUnit === weightUnitOfSecondBag ? t('Product.BaggagePerTraveler.Weight', weightOfSecondBag, weightUnitOfSecondBag) : '';
  const piecesDescription = weight === weightOfSecondBag && numberOfPieces ? `${t('Product.BaggagePerTraveler.Pieces', numberOfPieces + (piecesOfSecondBag || 0))}` : '';
  const combinedBagWeightDescription = `${piecesDescription !== null && piecesDescription !== void 0 ? piecesDescription : ''} ${weightDescription}`;
  return combinedBagWeightDescription.trim();
};
export const formSeparateBagWeightDescription = _ref5 => {
  let {
    weight,
    weightUnit,
    numberOfPieces,
    piecesOfSecondBag,
    weightOfSecondBag,
    weightUnitOfSecondBag,
    t
  } = _ref5;
  const checkedBagPieceText = t('Product.BaggagePerTraveler.Pieces', numberOfPieces);
  const checkedBagWeightText = t('Product.BaggagePerTraveler.Weight', weight, weightUnit);
  const secondBagPieceText = t('Product.BaggagePerTraveler.Pieces', piecesOfSecondBag);
  const secondBagWeightText = t('Product.BaggagePerTraveler.Weight', weightOfSecondBag, weightUnitOfSecondBag);
  const separateBagWeightDescription = `${checkedBagPieceText} ${checkedBagWeightText} + ${secondBagPieceText} ${secondBagWeightText}`;
  return separateBagWeightDescription.trim();
};
export const generateCheckedBaggageMultiWeightContent = (checkedBagOptions, titleChoiceNo, travelerId, t) => {
  const options = checkedBagOptions.map(checkedBagOption => {
    var _price$price$value, _price$price, _price$markup$value, _price$markup;
    const {
      ancillaryCarrierPriceBreakdowns,
      weight: checkedBagWeight,
      numberOfUnits: checkedBagNumberOfPieces,
      weightUnit: checkedBagWeightUnit,
      price
    } = checkedBagOption;
    const baggageDescription = formCheckedBaggageWeightSizeDescription({
      weight: checkedBagWeight,
      weightUnit: checkedBagWeightUnit,
      numberOfPieces: checkedBagNumberOfPieces,
      t
    });
    const weightAndUnit = `${checkedBagWeight}${checkedBagWeightUnit}`;
    const selectedWeight = checkedBagWeight !== null && checkedBagWeight !== void 0 ? checkedBagWeight : null;
    return {
      id: `content-${weightAndUnit}-${BAGGAGE_VALUES.TRUE}-${travelerId}`,
      label: baggageDescription,
      ancillaryCarrierPriceBreakdowns,
      priceRaw: (_price$price$value = price === null || price === void 0 || (_price$price = price.price) === null || _price$price === void 0 ? void 0 : _price$price.value) !== null && _price$price$value !== void 0 ? _price$price$value : 0,
      value: `${BAGGAGE_VALUES.TRUE}-${weightAndUnit}`,
      markup: (_price$markup$value = price === null || price === void 0 || (_price$markup = price.markup) === null || _price$markup === void 0 ? void 0 : _price$markup.value) !== null && _price$markup$value !== void 0 ? _price$markup$value : 0,
      selectedWeight
    };
  });
  return [{
    id: `content-${BAGGAGE_VALUES.FALSE}-${travelerId}`,
    label: titleChoiceNo,
    ancillaryCarrierPriceBreakdowns: [],
    priceRaw: 0,
    value: BAGGAGE_VALUES.FALSE,
    markup: 0,
    selectedWeight: null
  }, ...options];
};
export const generateCheckedBaggageSingleWeightContent = _ref6 => {
  let {
    ancillaryCarrierPriceBreakdowns,
    baggageDescription,
    markup,
    productPrice,
    titleChoiceNo,
    travelerId
  } = _ref6;
  return [{
    id: `content-${BAGGAGE_VALUES.FALSE}-${travelerId}`,
    label: titleChoiceNo,
    ancillaryCarrierPriceBreakdowns: [],
    priceRaw: 0,
    value: BAGGAGE_VALUES.FALSE,
    markup: 0
  }, {
    id: `content-${BAGGAGE_VALUES.TRUE}-${travelerId}`,
    label: baggageDescription,
    ancillaryCarrierPriceBreakdowns,
    priceRaw: productPrice,
    value: BAGGAGE_VALUES.TRUE,
    markup
  }];
};
export const generateCombinedBaggageContent = _ref7 => {
  let {
    ancillaryCarrierPriceBreakdowns,
    titleChoiceNo,
    baggageDescription,
    productPrice,
    travelerId,
    combinedBagPrice,
    combinedBagDescription,
    secondBagProductId,
    markup
  } = _ref7;
  return [{
    id: `content-${BAGGAGE_VALUES.FALSE}-${travelerId}`,
    label: titleChoiceNo,
    ancillaryCarrierPriceBreakdowns: [],
    priceRaw: 0,
    markup: 0,
    value: BAGGAGE_VALUES.FALSE
  }, {
    id: `content-singlebag-${BAGGAGE_VALUES.TRUE}-${travelerId}`,
    label: baggageDescription,
    ancillaryCarrierPriceBreakdowns,
    priceRaw: productPrice,
    value: BAGGAGE_VALUES.TRUE,
    markup
  }, {
    id: `content-combinedbag-${BAGGAGE_VALUES.TRUE}-${travelerId}`,
    label: combinedBagDescription,
    ancillaryCarrierPriceBreakdowns,
    priceRaw: combinedBagPrice,
    secondBagProductId,
    value: BAGGAGE_VALUES.COMBINED,
    markup
  }];
};
const getCheckedBaggageMultiWeightOptions = _ref8 => {
  let {
    checkedBagOptions,
    traveler,
    titleChoiceNo,
    t
  } = _ref8;
  return generateCheckedBaggageMultiWeightContent(checkedBagOptions, titleChoiceNo, traveler === null || traveler === void 0 ? void 0 : traveler.id, t);
};
export const getCheckedAndSecondBagOption = _ref9 => {
  var _traveler$markup, _traveler$markup2;
  let {
    checkedBagOptions,
    secondBagOptions,
    traveler,
    titleChoiceNo,
    secondBagTraveler,
    secondBagProductId,
    t
  } = _ref9;
  const {
    weight: weightOfSecondBag = 0,
    numberOfUnits: piecesOfSecondBag = 0,
    weightUnit: weightUnitOfSecondBag = ''
  } = secondBagOptions[0] || {};
  const {
    ancillaryCarrierPriceBreakdowns,
    weight: checkedBagWeight,
    numberOfUnits: checkedBagNumberOfPieces,
    weightUnit: checkedBagWeightUnit
  } = checkedBagOptions[0] || {};
  const baggageDescription = formCheckedBaggageWeightSizeDescription({
    weight: checkedBagWeight,
    weightUnit: checkedBagWeightUnit,
    numberOfPieces: checkedBagNumberOfPieces,
    t
  });
  const hasSecondBag = piecesOfSecondBag && piecesOfSecondBag > 0;
  const combinedBagDescription = hasSecondBag && checkedBagWeight === weightOfSecondBag ? formCombinedBagWeightDescription({
    weight: checkedBagWeight,
    weightUnit: checkedBagWeightUnit,
    numberOfPieces: checkedBagNumberOfPieces,
    piecesOfSecondBag,
    weightOfSecondBag,
    weightUnitOfSecondBag,
    t
  }) : formSeparateBagWeightDescription({
    weight: checkedBagWeight,
    weightUnit: checkedBagWeightUnit,
    numberOfPieces: checkedBagNumberOfPieces,
    piecesOfSecondBag,
    weightOfSecondBag,
    weightUnitOfSecondBag,
    t
  });
  const baggageRadioButtonContent = hasSecondBag ? generateCombinedBaggageContent({
    ancillaryCarrierPriceBreakdowns,
    titleChoiceNo,
    baggageDescription,
    productPrice: traveler === null || traveler === void 0 ? void 0 : traveler.price,
    markup: (_traveler$markup = traveler === null || traveler === void 0 ? void 0 : traveler.markup) !== null && _traveler$markup !== void 0 ? _traveler$markup : 0,
    travelerId: (traveler === null || traveler === void 0 ? void 0 : traveler.id) || '',
    combinedBagPrice: ((secondBagTraveler === null || secondBagTraveler === void 0 ? void 0 : secondBagTraveler.price) || 0) + ((traveler === null || traveler === void 0 ? void 0 : traveler.price) || 0),
    combinedBagDescription,
    secondBagProductId
  }) : generateCheckedBaggageSingleWeightContent({
    ancillaryCarrierPriceBreakdowns,
    baggageDescription,
    markup: (_traveler$markup2 = traveler === null || traveler === void 0 ? void 0 : traveler.markup) !== null && _traveler$markup2 !== void 0 ? _traveler$markup2 : 0,
    productPrice: (traveler === null || traveler === void 0 ? void 0 : traveler.price) || 0,
    travelerId: traveler === null || traveler === void 0 ? void 0 : traveler.id,
    titleChoiceNo
  });
  return baggageRadioButtonContent;
};
export const getBaggageRadioButtonOptions = _ref10 => {
  let {
    checkedBagOptions,
    hasMultipleWeightOptions,
    secondBagOptions,
    traveler,
    titleChoiceNo,
    secondBagTraveler,
    secondBagProductId,
    t
  } = _ref10;
  let baggageOptions;
  if (hasMultipleWeightOptions) {
    baggageOptions = getCheckedBaggageMultiWeightOptions({
      checkedBagOptions,
      traveler,
      titleChoiceNo,
      t
    });
  } else {
    baggageOptions = getCheckedAndSecondBagOption({
      checkedBagOptions,
      secondBagOptions,
      traveler,
      titleChoiceNo,
      secondBagTraveler,
      secondBagProductId,
      t
    });
  }
  return {
    baggageOptions
  };
};
export const bundleBaggageDetails = bundleData => {
  var _bundleData$options, _bundleContents$conte;
  const bundleContents = bundleData === null || bundleData === void 0 || (_bundleData$options = bundleData.options) === null || _bundleData$options === void 0 ? void 0 : _bundleData$options.find(option => (option === null || option === void 0 ? void 0 : option.id) !== undefined && option.id === bundleData.selectedOption);
  return bundleContents === null || bundleContents === void 0 || (_bundleContents$conte = bundleContents.content) === null || _bundleContents$conte === void 0 ? void 0 : _bundleContents$conte.find(bundleContent => (bundleContent === null || bundleContent === void 0 ? void 0 : bundleContent.productTypeId) === CHECK_IN_BAGGAGE.id.toString());
};
export const checkedBaggageBundlePiecesWeight = bundleData => {
  const bundleCheckedBaggageDetails = bundleBaggageDetails(bundleData);
  const {
    pieces,
    weight,
    weightUnit
  } = bundleCheckedBaggageDetails || {};
  return {
    pieces: pieces !== null && pieces !== void 0 ? pieces : undefined,
    weight: weight !== null && weight !== void 0 ? weight : undefined,
    weightUnit: weightUnit !== null && weightUnit !== void 0 ? weightUnit : undefined
  };
};
export const checkedBaggageIncludedPiecesWeight = includedBaggage => {
  const {
    pieces,
    weight,
    weightUnit
  } = includedBaggage !== null && includedBaggage !== void 0 ? includedBaggage : {};
  return {
    pieces: pieces !== null && pieces !== void 0 ? pieces : null,
    weight: weight !== null && weight !== void 0 ? weight : undefined,
    weightUnit: weightUnit !== null && weightUnit !== void 0 ? weightUnit : undefined
  };
};
export const getIncludedBaggagePiecesWeightPrimaryFlow = (includedBaggage, bundleData, t) => {
  var _checkedBaggageBundle;
  const {
    pieces: includedPieces,
    weight: includedWeight,
    weightUnit: includedWeightUnit
  } = includedBaggage !== null && includedBaggage !== void 0 ? includedBaggage : {};
  const {
    pieces: bundlePieces,
    weight: bundleWeight,
    weightUnit: bundleWeightUnit
  } = (_checkedBaggageBundle = checkedBaggageBundlePiecesWeight(bundleData)) !== null && _checkedBaggageBundle !== void 0 ? _checkedBaggageBundle : {};
  const pieces = includedPieces !== null && includedPieces !== void 0 ? includedPieces : bundlePieces;
  const weight = includedWeight !== null && includedWeight !== void 0 ? includedWeight : bundleWeight;
  const weightUnit = includedWeightUnit !== null && includedWeightUnit !== void 0 ? includedWeightUnit : bundleWeightUnit;
  if (!pieces && !weight) {
    return undefined;
  }
  const piecesDescription = pieces ? `${t('Product.BaggagePerTraveler.Pieces', pieces)}` : '';
  const weightDescription = weight ? t('Product.BaggagePerTraveler.Weight', weight, weightUnit) : '';
  return `${piecesDescription} ${weightDescription}`.trim();
};
//# sourceMappingURL=checkInBaggageUtils.js.map